var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle12({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 200,
    viewBox: "0 0 1440 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V190C1440 195.523 1435.52 200 1430 200H9.99996C4.47711 200 0 195.523 0 190V0Z",
    fill: "#FED15E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle12);
export default __webpack_public_path__ + "static/media/rectangle-12.d80db627fdd6c902d85d7d95fa3f6a9f.svg";
export { ForwardRef as ReactComponent };